/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type ReactNode } from 'react';

import { css, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const styles = css({
	paddingLeft: token('space.100', '8px'),
	paddingRight: token('space.100', '8px'),
	width: '230px',
	// eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors
	'.custom-item-style': {
		borderRadius: token('radius.small'),
		paddingLeft: token('space.100', '8px'),
		paddingRight: token('space.100', '8px'),
		// eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors
		'[data-item-elem-before]': {
			minWidth: 'unset',
		},
		// eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors
		svg: {
			color: token('color.text.subtle'),
		},
	},
});

type ItemWrapperProps = {
	children: ReactNode;
	isMenuItem?: boolean;
};

export default function ItemWrapper({ children, isMenuItem = true }: ItemWrapperProps) {
	const wrappedItemRole = isMenuItem ? 'listitem' : undefined;

	return (
		<div css={styles} role={wrappedItemRole}>
			{children}
		</div>
	);
}
